import React from 'react';
import { Checkbox } from 'antd';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { FormItem } from 'component/form_component/style';

export default function UserFormCheckbox({ checkboxrecord, label, value, form, className }) {
  const handleCheckboxChange = async (key) => {
    const currentChecked = form.getFieldValue(key);

    if (key === 'passwordAtNextLogon') {
      if (
        currentChecked &&
        form.getFieldValue('userCannotChangePassword') &&
        form.getFieldValue('passwordNeverExpires')
      ) {
        await SweetSweetAlert({
          icon: 'info',
          text: 'You specified that the password should never expire.The user will not be required to change the password at next login',
          buttonColor: 'blue',
        });
        form.setFieldsValue({ passwordAtNextLogon: false, userCannotChangePassword: true, passwordNeverExpires: true });
      }
      // If passwordAtNextLogon is active and userCannotChangePassword is clicked, set passwordAtNextLogon active
      else if (currentChecked && form.getFieldValue('userCannotChangePassword')) {
        await SweetSweetAlert({
          icon: 'info',
          text: 'You cannot check both User must change password on next login and User cannot change password for the same user',
          buttonColor: 'blue',
        });
        form.setFieldsValue({
          passwordAtNextLogon: true,
          userCannotChangePassword: false,
          passwordNeverExpires: false,
        });
      }
      // If passwordAtNextLogon is active and passwordNeverExpires is clicked, set passwordNeverExpires active
      else if (currentChecked && form.getFieldValue('passwordNeverExpires')) {
        await SweetSweetAlert({
          icon: 'info',
          text: 'You specified that the password should never expire.The user will not be required to change the password at next login',
          buttonColor: 'blue',
        });
        form.setFieldsValue({
          passwordAtNextLogon: false,
          userCannotChangePassword: false,
          passwordNeverExpires: true,
        });
      }
    } else if (key === 'userCannotChangePassword') {
      // If userCannotChangePassword is active and passwordAtNextLogon is clicked, set passwordAtNextLogon active
      if (currentChecked && form.getFieldValue('passwordAtNextLogon')) {
        await SweetSweetAlert({
          icon: 'info',
          text: 'You cannot check both User must change password on next login and User cannot change password for the same user',
          buttonColor: 'blue',
        });
        form.setFieldsValue({
          passwordAtNextLogon: true,
          userCannotChangePassword: false,
          passwordNeverExpires: false,
        });
      }
      // If userCannotChangePassword is active and passwordNeverExpires is clicked, set userCannotChangePassword and passwordNeverExpires active
      else if (currentChecked && form.getFieldValue('passwordNeverExpires')) {
        form.setFieldsValue({ passwordAtNextLogon: false, userCannotChangePassword: true, passwordNeverExpires: true });
      }
    } else if (key === 'passwordNeverExpires') {
      // If passwordNeverExpires is active and passwordAtNextLogon is clicked, set passwordNeverExpires active
      if (currentChecked && form.getFieldValue('passwordAtNextLogon')) {
        await SweetSweetAlert({
          icon: 'info',
          text: 'You specified that the password should never expire.The user will not be required to change the password at next login',
          buttonColor: 'blue',
        });
        form.setFieldsValue({
          passwordAtNextLogon: false,
          userCannotChangePassword: false,
          passwordNeverExpires: true,
        });
      }
      // If passwordNeverExpires is active and userCannotChangePassword is clicked, set userCannotChangePassword and passwordNeverExpires active
      else if (currentChecked && form.getFieldValue('userCannotChangePassword')) {
        form.setFieldsValue({ passwordAtNextLogon: false, userCannotChangePassword: true, passwordNeverExpires: true });
      }
    }
  };

  return (
    <FormItem
      style={{ margin: '0px' }}
      name={value}
      valuePropName='checked'
      initialValue={
        checkboxrecord
          ? (value === 'passwordAtNextLogon' && checkboxrecord.passwordAtNextLogon) ||
            (value === 'passwordNeverExpires' && checkboxrecord.passwordNeverExpires) ||
            (value === 'userCannotChangePassword' && checkboxrecord.userCannotChangePassword) ||
            (value === 'disable' && !checkboxrecord.isEnabled)
          : value === 'passwordAtNextLogon'
      }
    >
      <Checkbox className={`af-form-checkbox ${className}`} onChange={(e) => handleCheckboxChange(value)}>
        {label}
      </Checkbox>
    </FormItem>
  );
}
